module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "promotion-streamMedia",
    class: {
      'en-style': _vm.language === 'en'
    }
  }, [_c('div', {
    staticClass: "container-top"
  }, [_c('plex-header', {
    staticStyle: {
      "width": "100%"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "banner-wrap container"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('banner_title')))]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "left-wrap"
  }, [_c('p', {
    staticClass: "des"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('banner_des1')) + "\n              ")]), _vm._v(" "), _c('p', {
    staticClass: "des"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('banner_des2')) + "\n              ")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v(_vm._s(_vm.$t('banner_btn')))])], 1), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('img', {
    staticClass: "right-img",
    attrs: {
      "src": require("../../../../static/img/promotion/streamMedia-right.png"),
      "alt": ""
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "whyneed-wrap"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('whyNeed_title')))]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "item"
  }, [_vm._m(1), _vm._v(" "), _c('p', {
    staticClass: "des"
  }, [_vm._v(_vm._s(_vm.$t('whyNeed_des1')))])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_vm._m(2), _vm._v(" "), _c('p', {
    staticClass: "des"
  }, [_vm._v(_vm._s(_vm.$t('whyNeed_des2')))])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_vm._m(3), _vm._v(" "), _c('p', {
    staticClass: "des"
  }, [_vm._v(_vm._s(_vm.$t('whyNeed_des3')))])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_vm._m(4), _vm._v(" "), _c('p', {
    staticClass: "des"
  }, [_vm._v(_vm._s(_vm.$t('whyNeed_des4')))])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_vm._m(5), _vm._v(" "), _c('p', {
    staticClass: "des"
  }, [_vm._v(_vm._s(_vm.$t('whyNeed_des5')))])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_vm._m(6), _vm._v(" "), _c('p', {
    staticClass: "des"
  }, [_vm._v(_vm._s(_vm.$t('whyNeed_des6')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "benefit-wrap"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('benefit_title')))]), _vm._v(" "), _c('div', {
    staticClass: "benefit"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box "
  }, [_c('div', {
    staticClass: "item"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "des"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('benefit_item1')) + "\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "des"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('benefit_item2')) + "\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "des"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('benefit_item3')) + "\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "des"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('benefit_item4')) + "\n                  ")])])])])]), _vm._v(" "), _c('router-link', {
    staticClass: "down-btn",
    attrs: {
      "to": "/download"
    }
  }, [_vm._v(_vm._s(_vm.$t('downloadPlex')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "stream-list-wrap"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('stream_list_title')))]), _vm._v(" "), _c('div', {
    staticClass: "content content1"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "item"
  }, [_vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "info-wrap"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('stream_list_title1')))]), _vm._v(" "), _c('p', {
    staticClass: "des"
  }, [_vm._v(_vm._s(_vm.$t('stream_list_des1')))])]), _vm._v(" "), _c('div', {
    staticClass: "movie-wrap"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('stream_list_moive')))]), _vm._v(" "), _c('p', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$tc('stream_list_moive1', 0)))]), _vm._v(" "), _c('p', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$tc('stream_list_moive1', 1)))]), _vm._v(" "), _c('p', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$tc('stream_list_moive1', 2)))])])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "info-wrap"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('stream_list_title2')))]), _vm._v(" "), _c('p', {
    staticClass: "des"
  }, [_vm._v(_vm._s(_vm.$t('stream_list_des2')))])]), _vm._v(" "), _c('div', {
    staticClass: "movie-wrap"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('stream_list_moive')))]), _vm._v(" "), _c('p', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$tc('stream_list_moive2', 0)))]), _vm._v(" "), _c('p', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$tc('stream_list_moive2', 1)))]), _vm._v(" "), _c('p', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$tc('stream_list_moive2', 2)))])])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "info-wrap"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('stream_list_title3')))]), _vm._v(" "), _c('p', {
    staticClass: "des"
  }, [_vm._v(_vm._s(_vm.$t('stream_list_des3')))])]), _vm._v(" "), _c('div', {
    staticClass: "movie-wrap"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('stream_list_moive')))]), _vm._v(" "), _c('p', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$tc('stream_list_moive3', 0)))]), _vm._v(" "), _c('p', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$tc('stream_list_moive3', 1)))]), _vm._v(" "), _c('p', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$tc('stream_list_moive3', 2)))])])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "info-wrap"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('stream_list_title4')))]), _vm._v(" "), _c('p', {
    staticClass: "des"
  }, [_vm._v(_vm._s(_vm.$t('stream_list_des4')))])]), _vm._v(" "), _c('div', {
    staticClass: "movie-wrap"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('stream_list_moive')))]), _vm._v(" "), _c('p', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$tc('stream_list_moive4', 0)))]), _vm._v(" "), _c('p', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$tc('stream_list_moive4', 1)))]), _vm._v(" "), _c('p', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$tc('stream_list_moive4', 2)))])])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "info-wrap"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('stream_list_title5')))]), _vm._v(" "), _c('p', {
    staticClass: "des"
  }, [_vm._v(_vm._s(_vm.$t('stream_list_des5')))])]), _vm._v(" "), _c('div', {
    staticClass: "movie-wrap"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('stream_list_moive')))]), _vm._v(" "), _c('p', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$tc('stream_list_moive5', 0)))]), _vm._v(" "), _c('p', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$tc('stream_list_moive5', 1)))]), _vm._v(" "), _c('p', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$tc('stream_list_moive5', 2)))])])])])]), _vm._v(" "), _vm._m(16), _vm._v(" "), _c('div', {
    staticClass: "content content2"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "item"
  }, [_vm._m(17), _vm._v(" "), _c('div', {
    staticClass: "info-wrap"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('stream_list_title6')))]), _vm._v(" "), _c('p', {
    staticClass: "des"
  }, [_vm._v(_vm._s(_vm.$t('stream_list_des6')))])])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_vm._m(18), _vm._v(" "), _c('div', {
    staticClass: "info-wrap"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('stream_list_title7')))]), _vm._v(" "), _c('p', {
    staticClass: "des"
  }, [_vm._v(_vm._s(_vm.$t('stream_list_des7')))])])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_vm._m(19), _vm._v(" "), _c('div', {
    staticClass: "info-wrap"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('stream_list_title8')))]), _vm._v(" "), _c('p', {
    staticClass: "des"
  }, [_vm._v(_vm._s(_vm.$t('stream_list_des8')))])])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_vm._m(20), _vm._v(" "), _c('div', {
    staticClass: "info-wrap"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('stream_list_title9')))]), _vm._v(" "), _c('p', {
    staticClass: "des"
  }, [_vm._v(_vm._s(_vm.$t('stream_list_des9')))])])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_vm._m(21), _vm._v(" "), _c('div', {
    staticClass: "info-wrap"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('stream_list_title10')))]), _vm._v(" "), _c('p', {
    staticClass: "des"
  }, [_vm._v(_vm._s(_vm.$t('stream_list_des10')))])])])])]), _vm._v(" "), _vm._m(22)]), _vm._v(" "), _c('div', {
    staticClass: "features"
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('feature_title')))]), _vm._v(" "), _c('div', {
    staticClass: "ftu-text1"
  }, [_c('div', [_c('span', [_vm._v(_vm._s(_vm.$t('features_title1')))]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v(_vm._s(_vm.$t('features_con1')))])]), _vm._v(" "), _c('div', [_c('span', [_vm._v(_vm._s(_vm.$t('features_title2')))]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v(_vm._s(_vm.$t('features_con2')))])]), _vm._v(" "), _c('div', [_c('span', [_vm._v(_vm._s(_vm.$t('features_title3')))]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v(_vm._s(_vm.$t('features_con3')))])])]), _vm._v(" "), _c('div', {
    staticClass: "ftu-text2"
  }, [_c('div', [_c('span', [_vm._v(_vm._s(_vm.$t('features_title4')))]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v(_vm._s(_vm.$t('features_con4')))])]), _vm._v(" "), _c('div', [_c('span', [_vm._v(_vm._s(_vm.$t('features_title5')))]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v(_vm._s(_vm.$t('features_con5')))])]), _vm._v(" "), _c('div', [_c('span', [_vm._v(_vm._s(_vm.$t('features_title6')))]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v(_vm._s(_vm.$t('features_con6')))])])]), _vm._v(" "), _c('router-link', {
    staticClass: "down-btn",
    attrs: {
      "to": "/"
    }
  }, [_vm._v(_vm._s(_vm.$t('getPlex')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [(_vm.language === 'zh') ? _c('img', {
    staticClass: "footer-icon",
    attrs: {
      "src": require("../../../../static/img/promotion/netflix-footer-icon.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.language === 'en') ? _c('img', {
    staticClass: "footer-icon",
    attrs: {
      "src": require("../../../../static/img/promotion/netflix-footer-icon-en.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('footer_con1')))]), _vm._v(" "), _vm._m(23), _vm._v(" "), _c('router-link', {
    staticClass: "down-btn",
    attrs: {
      "to": "/download"
    }
  }, [_vm._v(_vm._s(_vm.$t('downloadPlex')))])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right-wrap"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/streamMedia-right.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img-wrap"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/streamMedia-whyneed-img1.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img-wrap"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/streamMedia-whyneed-img2.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img-wrap"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/streamMedia-whyneed-img3.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img-wrap"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/streamMedia-whyneed-img4.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img-wrap"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/streamMedia-whyneed-img5.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img-wrap"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/streamMedia-whyneed-img6.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img-wrap"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/streamMedia-benefit1.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img-wrap"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/streamMedia-benefit2.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img-wrap"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/streamMedia-benefit3.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img-wrap"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/streamMedia-benefit4.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img-wrap"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/stream-list-netflix.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img-wrap"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/stream-list-bbc.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img-wrap"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/stream-list-hulu.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img-wrap"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/stream-list-hbo.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img-wrap"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/stream-list-disney.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dots-wrap dots-wrap1"
  }, [_c('span', {
    staticClass: "active"
  }), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img-wrap"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/stream-list-niconico.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img-wrap"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/stream-list-viu.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img-wrap"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/stream-list-abema.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img-wrap"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/stream-list-tver.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img-wrap"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/stream-list-dmm.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dots-wrap dots-wrap2"
  }, [_c('span', {
    staticClass: "active"
  }), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "star-wrap"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/netflix-star.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/netflix-star.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/netflix-star.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/netflix-star.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/netflix-star.png"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-80892072!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/promotion/StreamMedia/StreamMedia.vue
// module id = 1362
// module chunks = 1